
export const ADD_TOAST = Symbol('toasts/ADD_TOAST');

export const REMOVE_TOAST = Symbol('toasts/REMOVE_TOAST');